class DealSheetConfigurationMapper {
  processSalesCenterFormToAPIDto(formData: Record<string, any>): Record<string, any> {
    return {
      charges: [],
      name: formData.name,
      ...(formData.description ? { description: formData.description } : {}),
      dealRules: {
        saleType: formData.saleType ? formData.saleType : null,
        paymentType: formData.paymentType ? formData.paymentType : null,
        equipmentType: formData.equipmentType ? formData.equipmentType : null,
        location: {
          ...(formData.state ? { state: formData.state } : {}),
          ...(formData.county ? { county: formData.county } : {}),
          ...(formData.country ? { country: formData.country } : {}),
        },
      },
    };
  }
}

export const dealSheetConfigurationMapper = new DealSheetConfigurationMapper();
